import {FC, ReactNode, useMemo} from 'react';
import { NavBarTheming } from './types';
import { useBreakpoint, NavBarUI } from '@brg/ui';
import { AppTester } from "../../../../../supporting";
import { useRouteMatch } from "react-router-dom";
import { LinkTo } from "../../../../constants/linkTo";
import { LayoutConst } from 'core';
import { useSelector } from "react-redux";
import {useTranslation} from "react-i18next";

export interface NavBarProps {
  logo: JSX.Element;
  context?:  string;
  sections: JSX.Element[][];
  oneSection?: boolean;
  theming: NavBarTheming;
  subBar?: JSX.Element;
  onLogoClick?: () => void;
  errorComponent?: ReactNode;
  children?: ReactNode;
}

export const NavBar: FC<NavBarProps> = ({ logo, children, errorComponent, sections, oneSection, theming, subBar }) => {

  const isEditPage = useRouteMatch(LinkTo.projectEdit);
  const isHSEDesign = AppTester.isHSEDesign();
  const is568bp = useBreakpoint(LayoutConst.screen.sm);
  const isLegals = useRouteMatch([LinkTo.legals, '/school/legals']);
  const isTeamEdit = useRouteMatch('/team-edit');
  const isOnlines = AppTester.isOnlines();
  const longreadVisible = useSelector((state: any) => state.vt.longreadVisible);
  const isIqMedia = AppTester.isIqMediiia();

  const isProjectPage = useRouteMatch(LinkTo.project);
  const isCreateLocation = !!useRouteMatch('/createLocation'); 
  const sectionShifted = useMemo(() => (is568bp && isHSEDesign), [is568bp, isHSEDesign]);
  const { i18n } = useTranslation()

  if (isIqMedia) {
    return null
  }

  return (
      <NavBarUI
          logo={logo}
          sections={sections}
          theming={theming}
          subBar={subBar}
          isSectionShifted={sectionShifted}
          oneSection={oneSection}
          shouldDisplayScrollUpZone={!isEditPage && !isProjectPage && !isTeamEdit && !isCreateLocation}
          errorComponent={errorComponent}
          shouldHideZone={Boolean(isLegals || longreadVisible)}
          isTopText={isOnlines || i18n?.language === 'en'}
          children={children}
          navbarStyles={{minHeight: 'auto'}}
      />
  );
};
import {FC, ReactNode, useMemo} from 'react';
import { NavBarTheming } from './types';
import { useBreakpoint, NavBarUI } from '@brg/ui';
import { AppTester } from "../../../../../supporting";
import { useRouteMatch } from "react-router-dom";
import { LinkTo } from "../../../../constants/linkTo";
import { LayoutConst } from 'core';
import { useSelector } from "react-redux";
import {useTranslation} from "react-i18next";

export interface NavBarProps {
  logo: JSX.Element;
  context?:  string;
  sections: JSX.Element[][];
  oneSection?: boolean;
  theming: NavBarTheming;
  subBar?: JSX.Element;
  onLogoClick?: () => void;
  errorComponent?: ReactNode;
  children?: ReactNode;
}

export const NavBar: FC<NavBarProps> = ({ logo, children, errorComponent, sections, oneSection, theming, subBar }) => {

  const isEditPage = useRouteMatch(LinkTo.projectEdit);
  const isHSEDesign = AppTester.isHSEDesign();
  const is568bp = useBreakpoint(LayoutConst.screen.sm);
  const isLegals = useRouteMatch([LinkTo.legals, '/school/legals']);
  const isTeamEdit = useRouteMatch('/team-edit');
  const isOnlines = AppTester.isOnlines();
  const longreadVisible = useSelector((state: any) => state.vt.longreadVisible);
  const isIqMedia = AppTester.isIqMediiia();

  const isProjectPage = useRouteMatch(LinkTo.project);
  const isCreateLocation = !!useRouteMatch('/createLocation'); 
  const sectionShifted = useMemo(() => (is568bp && isHSEDesign), [is568bp, isHSEDesign]);
  const { i18n } = useTranslation()

  if (isIqMedia) {
    return null
  }

  return (
      <NavBarUI
          logo={logo}
          sections={sections}
          theming={theming}
          subBar={subBar}
          isSectionShifted={sectionShifted}
          oneSection={oneSection}
          shouldDisplayScrollUpZone={!isEditPage && !isProjectPage && !isTeamEdit && !isCreateLocation}
          errorComponent={errorComponent}
          shouldHideZone={Boolean(isLegals || longreadVisible)}
          isTopText={isOnlines || i18n?.language === 'en'}
          children={children}
          navbarStyles={{minHeight: 'auto'}}
      />
  );
};
